export interface IDropDownItem {
  id: string;
  display: string;
  isSelected: boolean;
}
